import styles from "../styles/PaginationNav.module.scss"
import cx from "classnames"

/**
 * 
 * @param {Number} count - Total number of results that are being paginated 
 * @param {Number} activePage - Current page
 * @param {Callback} setActivePage(activePage:Number) - function passed in to by parent that takes new current page
 * @param {Number} maxListOptions - Limits how many page options can be shown at a time
 * @param {Number} resultsPerPage - Number of results to show on a given page
 * @returns Generic Pagination Navigation element 
 */
const PaginatedNavComponent = ({count, activePage, setActivePage, maxListOptions, resultsPerPage}) => {
  if (count <= resultsPerPage){
    return false
  }
  
  const getPageList = (totalPages, page, maxLength) => {
    if (maxLength < 5) throw "maxLength must be at least 5"

    function range(start, end) {
      return Array.from(Array(end - start + 1), (_, i) => i + start)
    }

    var sideWidth = Math.ceil(maxLength / 2) - 1
    var rightWidth = (maxLength - sideWidth * 2 - 2) >> 1

    if (totalPages <= maxLength) {
      // List is too small to need breaking
      return range(1, totalPages)
    }
    if (page <= maxLength - sideWidth - 1 - rightWidth) {
      // Close to left side
      return range(1, maxLength)
    }
    if (page >= totalPages - sideWidth - 1) {
      // close to right side
      return range(totalPages - maxLength + 1, totalPages)
    }
    // Somewhere between
    return range(page - sideWidth, page + sideWidth)
  }

  const pages = Math.max(1, Math.ceil(count / resultsPerPage)) 

  return (
    <div className={styles.paginationContainer}>
      <ul className={styles.paginationList}>
        <li className={cx(styles.paginationListItem, activePage === 1 && styles.hidden)}>
          <a className="pageNavLink" aria-label="First" onClick={() => setActivePage(1)}>
            ‹‹
          </a>
        </li>
        <li className={cx(styles.paginationListItem, styles.desktop, activePage === 1 && styles.hidden)}>
          <a
            className="pageNavLink"
            aria-label="Previous"
            onClick={() => setActivePage(activePage - 1)}
          >
            ‹
          </a>
        </li>
        {[...getPageList(pages, activePage, maxListOptions)].map((i) => (
          <li className={cx(styles.paginationListItem)} key={i}>
            <a className={cx(activePage === i && styles.active)} onClick={() => setActivePage(i)}>
              {i}
            </a>
          </li>
        ))}
        <li
          className={cx(
            styles.paginationListItem,
            styles.next,
            styles.desktop,
            (activePage === pages || pages === 0) && styles.hidden
          )}
        >
          <a
            className="pageNavLink"
            aria-label="Next"
            onClick={() => setActivePage(activePage + 1)}
          >
            ›
          </a>
        </li>
        <li
          className={cx(
            styles.paginationListItem,
            (activePage === pages || pages === 0) && styles.hidden
          )}
        >
          <a className="pageNavLink" aria-label="Last" onClick={() => setActivePage(pages)}>
            ››
          </a>
        </li>
      </ul>
    </div>
  )
}

export default PaginatedNavComponent